import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ResearchShowcaseFilterOption extends BaseModel {
  static override constructorName = 'ResearchShowcaseFilterOption'

  id: string = ''
  name: string = ''
  isActive: boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ResearchShowcaseFilterOption)
